import React, {Component} from 'react'
import AmCharts from "@amcharts/amcharts3-react";


// Generate random data
// function generateData() {
//     var firstDate = new Date();
//
//     var dataProvider = [];
//
//     for (var i = 0; i < 100; ++i) {
//         var date = new Date(firstDate.getTime());
//
//         date.setDate(i);
//
//         dataProvider.push({
//             date: date,
//             value: Math.floor(Math.random() * 100)
//         });
//     }
//
//     return dataProvider;
// }

class PieChart extends Component {

    constructor(props) {
        super(props);
        // this.state = {
        //     dataProvider: generateData(),
        //     timer: null
        // };
    }

    componentDidMount() {
        // this.setState({
        //     // Update the chart dataProvider every 3 seconds
        //     timer: setInterval(() => {
        //         this.setState({
        //             dataProvider: generateData()
        //         });
        //     }, 40000)
        // });
        // console.log(this.state.dataProvider);

    }
    componentWillUnmount() {
        // clearInterval(this.state.timer);
    }

    render() {
    var fileName = ''
        if(this.props.name===null || this.props.name==='null' || this.props.name===undefined || this.props.name==='undefined') {
          fileName = "chartData"
        }
        fileName = this.props.name;
        const config = {
            "type": "pie",
            "legend": {

                "enabled": true,
                "position":"right",
                "valueWidth":60,
                "verticalGap":1,
                "markerSize":10,
                "markerLabelGap":3,
                "truncateLabels":30,
                "valueText": "[[percents]]%",
                "fontSize":9,
            },
            "groupPercent": 1,
            "theme": "default",
            "dataProvider": this.props.data,
            "valueField": this.props.y_axis,
            "titleField": this.props.x_axis,
            "outlineAlpha": 0.1,
            "radius": "25%",
            "labelRadius": 5,
            "fontSize":9,
            "balloon":{
                "fixedPosition":true,
            },
            "export": {
                "enabled": true,
                "fileName": fileName.replace(/ /g,"_"),
                "menu": [ {
                "class": "export-main",
                "menu": ["XLSX", "CSV" ],
              } ]
            }

        };
        return (
            <div className ="chart_div">
                <AmCharts.React style={{ width: "100%", height: "250px" }} options={config} />
            </div>
        );
    }
}

export default PieChart;